import { createLogic } from 'redux-logic'
import { SET_PROGRAM_OPTIONS } from '@app/constants/programOptions'
import { deps } from '@app/constants/channels'
import { PROGRAM_OPTIONS_TIMEOUT } from '@app/constants/timeouts'
import { setInitialOptions } from '@app/actions/programOptions'
import programOptionChannel from '@app/api/programOptions'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const submitProgramOptionsLogic = createLogic({
  type: SET_PROGRAM_OPTIONS,
  cancelType: API_REQUEST_CANCEL,
  warnTimeout: PROGRAM_OPTIONS_TIMEOUT,

  transform({ action }, next) {
    next({
      ...action,
    })
  },

  process({ action }, dispatch, done) {
    programOptionChannel({
      request: (channel) => {
        channel.perform('update_program_options', { programOptions: action.programOptions, ...deps })
        dispatch(apiRequestSent(SET_PROGRAM_OPTIONS))
      },

      response: (data, isFinished) => {
        const { programOptions, error } = data
        if (error && error.msg) {
          dispatch(apiRequestFailed(error.msg, error.code))
        } else {
          dispatch(setInitialOptions(programOptions))
          if (isFinished) {
            dispatch(apiRequestDone(SET_PROGRAM_OPTIONS))
          }
        }
        if (isFinished) {
          done()
        }
      },
    })
  },
})

export default submitProgramOptionsLogic
